import '../App.css';
import MainContent from '../components/MainContent';
import { useEffect, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, FormWhiteContainer, LightBlueContainer, ShortBlueButton, } from '../assets/style';
import { Box } from '@mui/material';
import FormLabel from '../components/FormLabel';
import { useLocation, useNavigate } from 'react-router';
import { userPageName } from '../components/PageName';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice'
import { useLazyGetUserRegistrationRequestDetailQuery } from '../features/auth/authApiSlice';
import { UserRegistrationRequestDetailModel } from '../models/UserRegistrationRequestModel';
import { formatDateTime } from '../utils/dateTimeFormmater';

const UserRegistrationRequestDetailPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const userRegistrationRequestId = getLocation.state?.userRegistrationRequestId;
    const [userRegistrationRequest, setUserRegistrationRequest] = useState<UserRegistrationRequestDetailModel | null>(null);
    const [getUserRegistrationRequestDetail, getUserRegistrationRequestDetailResult] = useLazyGetUserRegistrationRequestDetailQuery()

    const permissions = useSelector(selectPermissions)

    useEffect(() => {
        if (getLocation.state.userRegistrationRequest)
            setUserRegistrationRequest(getLocation.state.userRegistrationRequest)
        else if (userRegistrationRequestId) {
            getUserRegistrationRequestDetail(userRegistrationRequestId)
        }
    }, [])

    useEffect(() => {
        if (getUserRegistrationRequestDetailResult.isSuccess) {
            setUserRegistrationRequest(getUserRegistrationRequestDetailResult.data)
        }
    }, [getUserRegistrationRequestDetailResult.data])

    return (
        <MainContent type={userPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <BigHeading>{t("User Registration Request Detail")}</BigHeading>
                    <FormLabel title={t("User Name")} value={userRegistrationRequest?.name} />
                    <FormLabel title={t("Company Name")} value={userRegistrationRequest?.companyName} />
                    {<FormLabel title={t("Email")} value={userRegistrationRequest?.email} />}
                    <FormLabel title={t("Role Name")} value={userRegistrationRequest?.roleName} />
                    <FormLabel title={t("Applied at")} value={formatDateTime(userRegistrationRequest?.appliedAt)} />
                    <FormLabel title={t("Status")} value={userRegistrationRequest?.status} />
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        {/* <ShortBlueButton >{t("Save")}</ShortBlueButton> */}
                        <BackButton onClick={() => { navigate('/user', { state: { subpage: "userRegistrationList" } }) }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default UserRegistrationRequestDetailPage